import { b as d } from "./_baseGetTag-D86WGQCZ.js";
import { r as l } from "./isSymbol-CMDcKCTp.js";
var u, b;
function _() {
  if (b) return u;
  b = 1;
  function r(n, t) {
    for (var e = -1, a = n == null ? 0 : n.length, o = Array(a); ++e < a; )
      o[e] = t(n[e], e, n);
    return o;
  }
  return u = r, u;
}
var s, p;
function c() {
  if (p) return s;
  p = 1;
  var r = Array.isArray;
  return s = r, s;
}
var f, m;
function A() {
  if (m) return f;
  m = 1;
  var r = d(), n = _(), t = c(), e = l(), a = r ? r.prototype : void 0, o = a ? a.toString : void 0;
  function S(i) {
    if (typeof i == "string")
      return i;
    if (t(i))
      return n(i, S) + "";
    if (e(i))
      return o ? o.call(i) : "";
    var g = i + "";
    return g == "0" && 1 / i == -1 / 0 ? "-0" : g;
  }
  return f = S, f;
}
var y, q;
function v() {
  if (q) return y;
  q = 1;
  var r = A();
  function n(t) {
    return t == null ? "" : r(t);
  }
  return y = n, y;
}
export {
  _ as a,
  c as b,
  v as r
};
